/**
 * Organization services enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Service category labels
export const serviceCategoryLabels = {
    treatment: 'Treatment',
    procedure: 'Procedure',
    product: 'Product',
    consultation: 'Consultation',
    other: 'Other',
};
export const serviceCategoryValues = Object.keys(serviceCategoryLabels);
//# sourceMappingURL=organization-services.js.map